module.exports = __webpack_public_path__ + "static/media/upload.7b74d124.svg";